import type { WorkspaceModule } from '@/types/onboarding';
import { youtubeEnabled } from '@/lib/youtube/config';

export const RECOMMENDED_WORKSPACE_MODULE_IDS = [
  'gsc',
  'ga4',
  'webflow',
  'shopify',
  'intelligence',
] as const;
const DEFINITIONS = [
  ['youtube', 'YouTube', 'Track videos, Shorts, competitor activity, and AI citations.'],
  [
    'gsc',
    'Google Search Console',
    'Connect organic queries, pages, clicks and search performance.',
  ],
  ['ga4', 'Google Analytics', 'Connect page, channel, conversion and revenue data.'],
  ['webflow', 'Webflow Pages & CMS', 'Connect website pages, CMS drafts and publishing controls.'],
  ['shopify', 'Shopify', 'Connect products, store analytics and approved content updates.'],
  [
    'intelligence',
    'Attune Intelligence',
    'Track buyer questions across ChatGPT, Gemini and Google AI Overviews.',
  ],
  ['bing_webmaster', 'Bing Webmaster Tools', 'Connect Bing page and query performance.'],
  ['clarity', 'Microsoft Clarity', 'Connect UX friction snapshots from Clarity exports.'],
  ['cloudflare', 'Cloudflare', 'Connect web analytics, Core Web Vitals and AI crawler activity.'],
  ['openai_ads', 'ChatGPT Ads', 'Connect paid visibility through OpenAI Ads.'],
  ['google_workspace', 'Google Workspace', 'Export deliverables to Google Docs and Sheets.'],
  [
    'wordpress',
    'WordPress.com MCP',
    'Connect pages, posts, site statistics and approved publishing.',
  ],
  [
    'github',
    'Website via GitHub',
    'Connect a supported website repository and approved pull request delivery.',
  ],
  ['attune_mcp', 'Attune MCP', 'Connect external agent clients to your Attune workspace.'],
  ['custom_mcp', 'Custom MCP', 'Connect tools from your own HTTP MCP servers.'],
] as const;

export function getWorkspaceModuleCatalog(
  options: {
    projectId?: string | null;
    adsEnabled?: boolean;
    wordpressEnabled?: boolean;
    githubEnabled?: boolean;
    workspaceExportsEnabled?: boolean;
  } = {}
): WorkspaceModule[] {
  return DEFINITIONS.filter(([id]) => {
    if (id === 'youtube') return youtubeEnabled();
    if (id === 'openai_ads') return options.adsEnabled === true;
    if (id === 'wordpress') return options.wordpressEnabled === true;
    if (id === 'github') return options.githubEnabled === true;
    if (id === 'google_workspace') return options.workspaceExportsEnabled === true;
    return true;
  }).map(([id, name, description]) => ({
    id,
    name,
    description,
    recommended: (RECOMMENDED_WORKSPACE_MODULE_IDS as readonly string[]).includes(id),
    setupPath: `/app/workspace?setup=true${options.projectId ? `&project_id=${encodeURIComponent(options.projectId)}` : ''}&setup_module=${id}`,
  }));
}
